import { User } from 'features/auth';
import { Role } from 'features/auth/types';
import { createRepo } from 'lib/api/firebase';
import { Patient, Collection } from 'lib/documents';
import { Clinician } from 'lib/documents/clinician';

export async function getUser(user: Pick<User, 'role' | 'uid'>) {
  const userDataRepo = createRepo<Patient | Clinician>(
    [Role.ClinicAdmin, Role.Clinician].includes(user.role)
      ? Collection.Clinicians
      : Collection.Patients
  );
  const userData = await userDataRepo.find(user.uid);
  if (!userData) {
    throw new Error(
      `No user data for user (id=${user.uid}) found. Please report this error to your clinic`
    );
  }
  return userData;
}
